import React from "react";
import VariableListWrapper from "./VariableListWrapper";

const VariableList = (props) => {
  // Separate variables into accreditation and non-accreditation
  const accreditationVariables = props.list.filter(
    (v) => v.isAccreditationType
  );
  const regularVariables = props.list.filter((v) => !v.isAccreditationType);

  return (
    <>
      <VariableListWrapper
        title="Variables"
        variables={regularVariables}
        emptyMessage="No variable exists"
        handleVariableSelect={props.handleVariableSelect}
        handleVariableDelete={props.handleVariableDelete}
        selectedVariableId={props.selectedVariableId}
      />

      <VariableListWrapper
        title="Accreditation Variables"
        variables={accreditationVariables}
        emptyMessage="No accreditation variable exists"
        handleVariableSelect={props.handleVariableSelect}
        handleVariableDelete={props.handleVariableDelete}
        selectedVariableId={props.selectedVariableId}
      />
    </>
  );
};

export default VariableList;
